import React from 'react';
import { Outlet, Navigate, useLocation } from 'react-router-dom';
import { useAppSelector } from 'store/hook';
import { RootState } from 'store';

export function AuthenticateRoutes() {
  const userAuth = useAppSelector((state: RootState) => state.userAuth);
  return userAuth?.isLoggedIn ? (
    <Outlet />
  ) : (
    <Navigate to='/' />
  );
}

export function UnAuthenticateRoutes() {
  const userAuth = useAppSelector((state: RootState) => state.userAuth);
  const guestMode = useAppSelector((state: RootState) => state.guestMode);
  let location = useLocation();
  React.useEffect(() => {
    // Perform side effect whenever the location changes
    // console.log('Location changed:', location);
  }, [location]);

  return !userAuth?.isLoggedIn || location.pathname === '/privacy' ? (
    <Outlet />
  ) : (userAuth?.isLoggedIn && location.pathname === '/signin' && guestMode?.redirectTo) ? (
    <Navigate to={guestMode?.redirectTo} />
  ) : (
    <Navigate to='/home' />
  );
}

// eslint-disable-next-line import/no-anonymous-default-export
export default { AuthenticateRoutes, UnAuthenticateRoutes };
